import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {CustomField} from "../../entities/CustomFieldName";

export class CustomFieldNameModel {
    service:CustomFieldNameService;
    $q:ng.IQService;
    testName:string = "Big Daddy";
    customFields:CustomField[];
    customFieldValues:{ [id: string] : string; } = {};
    listValues:{ [id: string] : string[]; } = {};
    listValue1:string[] = [];
    listValue2:string[] = [];
    listValue3:string[] = [];
    listValue4:string[] = [];
    listValue5:string[] = [];
    public static $inject = ['$q','CustomFieldNameService'];
    constructor($q:ng.IQService, service:CustomFieldNameService){
        this.customFieldValues['asset.text'] = "Text1";
        this.service = service;
        this.$q = $q;
    }
    //connect makes sure that all data has been cached before proceeding to use the model
    connect():ng.IPromise<any>{
        var deferred = this.$q.defer();
        this.service.getAll().then((cfns)=> {
            this.customFields = cfns;
            var tempNameValues:{ [id: string] : string; } = {};
            var tempListValues:{ [id: string] : string[]; } = {};
            for(var i:number=0;i<cfns.length; i++){
                var val = cfns[i];
                tempNameValues[val.name] = val.value;
                var lvs = [''];
                for(var j:number=0; j<val.customFieldValues; j++){
                    var cfnv = val.customFieldValues[j];
                    lvs.push(cfnv.value);
                }
                var cfnvStrings = $.map(val.customFieldValues, (val,i)=>{
                    return val.value;
                });
                if(val.name=="asset.listvalue1")
                    this.listValue1 = cfnvStrings;
                if(val.name=="asset.listvalue2")
                    this.listValue2 = cfnvStrings;
                if(val.name=="asset.listvalue3")
                    this.listValue3 = cfnvStrings;
                if(val.name=="asset.listvalue4")
                    this.listValue4 = cfnvStrings;
                if(val.name=="asset.listvalue5")
                    this.listValue5 = cfnvStrings;
                //this[val.name] = lvs;
                tempListValues[val.name] = cfnvStrings;
            }
            this.customFieldValues = tempNameValues;
            this.listValues = tempListValues;
            deferred.resolve();
        });
        return deferred.promise;
    }
    getCustomField(cfnName:string):CustomField{
        var cfn:CustomField = null;
        for(var i=0; i< this.customFields.length;i++){
            if(this.customFields[i].name === cfnName)
            {
                cfn = this.customFields[i];
                break;
            }
        }
        return cfn;
    }
    getCustomFieldDisplayIndex(cfnName:string):number{
        var cfn:CustomField = this.getCustomField(cfnName);
        var index:number = cfn == null ? -1 : cfn.displayIndex;
        return index;
    }
    getCustomFieldDisplay(cfnName:string):boolean{
        var cfn:CustomField = this.getCustomField(cfnName);
        var display:boolean = cfn == null ? false : cfn.display;
        return display;
    }
    getCustomFieldValue(cfnName:string, defaultValue?:string):string{
        if(defaultValue == null)
            defaultValue = cfnName;
        var cfn:CustomField = this.getCustomField(cfnName);
        var textValue = cfn == null ? defaultValue : cfn.value;
        return textValue;
    }
}
